import { type ReactElement, type FC } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface Props {
	condition: boolean;
	children: ReactElement;
}

const UnsavedChangesTooltip: FC<Props> = ({ condition, children }) => {
	return condition ? (
		<OverlayTrigger
			overlay={
				<Tooltip id="tooltip-disabled">You have unsaved changes. Please save to proceed.</Tooltip>
			}>
			{children}
		</OverlayTrigger>
	) : (
		children
	);
};

export default UnsavedChangesTooltip;
